// componente para olvide mi contraseña

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { urls } from "../../api-urls/api-urls";



export const ForgotPassW = ({ onClose }) => {

  const language = localStorage.getItem("language") ?? window.navigator.language.slice(0, 2);

  // GET the react translation
  const [t] = useTranslation("global");

  const [email, setEmail] = useState("");
  const [emailVal, setEmailVal] = useState(true);
  const [emailSend, setEmailSend] = useState(false);
  const [error, setError] = useState("");


  // funcion para validar el email
  const onHandleValEmail = (newVal = "") => {
    const patron = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (patron.test(newVal)) {
      setEmailVal(false);
    } else {
      setEmailVal(true);
    }

    setEmail(newVal);
  };


  // funcion para enviar la inform al serv
  const onHandleSubmit = async (event) => {
    event.preventDefault();

    const END_POINT = `${urls.authRoute}/recover-passwd-ext-user?language=${language}`;

    try {
      setEmailVal(true);
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.status === 200) {
        setEmailSend(true);
        setEmailVal(true);
      } else if (response.status === 404) {
        setError(data?.msg);
      } else if (response.status === 500) {
        setError(data?.msg);
        setEmailVal(true);
      }

      setEmailVal(false);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="background-modal">
      <div className="container-modal-forg-passw">
        <div style={{ marginTop: "10px" }} className="row-flex j-content-s-b">
          <h4>{!emailSend ? t("HomeViewComp.olvidaste_pwd") : t("HomeViewComp.recibiste")}</h4>
          <button type="reset" className="btn-close" style={{ fontWeight: "bold" }} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
            </svg>
          </button>
        </div>
        {
          !emailSend && (
            <p className="txt-muted">
              {t("HomeViewComp.txt_olvidaste_pwd")}
            </p>
          )
        }

        {
          emailSend && (
            <>
              <p style={{ textAlign: "center" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none">
                  <path d="M31 60.5h.002A29.531 29.531 0 0 0 60.5 31.002V31A29.5 29.5 0 1 0 31 60.5Z" fill="#EFF2F5" stroke="#fff" strokeWidth="3" />
                  <mask id="a" maskUnits="userSpaceOnUse" x="38" y="38" width="26" height="26" fill="#000">
                    <path fill="#fff" d="M38 38h26v26H38z" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M51 61c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Zm4.756-12.345a1 1 0 1 0-1.512-1.31L49.8 52.473l-2.044-2.359a1 1 0 1 0-1.512 1.31l2.8 3.23a1 1 0 0 0 1.512 0l5.2-6Z" />
                  </mask>
                  <path fillRule="evenodd" clipRule="evenodd" d="M51 61c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Zm4.756-12.345a1 1 0 1 0-1.512-1.31L49.8 52.473l-2.044-2.359a1 1 0 1 0-1.512 1.31l2.8 3.23a1 1 0 0 0 1.512 0l5.2-6Z" fill="#16C784" />
                  <path d="m55.756 48.655 2.267 1.965-2.267-1.965Zm-1.512-1.31-2.267-1.965 2.267 1.965ZM49.8 52.473l-2.267 1.965 2.267 2.616 2.267-2.616-2.267-1.965Zm-2.044-2.359 2.267-1.964-2.267 1.964Zm-1.41-.1 1.964 2.267-1.965-2.267Zm-.102 1.41-2.267 1.965 2.267-1.965Zm2.8 3.23 2.267-1.964-2.267 1.965Zm1.512 0-2.267-1.964 2.267 1.965ZM58 51a7 7 0 0 1-7 7v6c7.18 0 13-5.82 13-13h-6Zm-7-7a7 7 0 0 1 7 7h6c0-7.18-5.82-13-13-13v6Zm-7 7a7 7 0 0 1 7-7v-6c-7.18 0-13 5.82-13 13h6Zm7 7a7 7 0 0 1-7-7h-6c0 7.18 5.82 13 13 13v-6Zm2.69-8.489a2 2 0 0 1-.201-2.82l4.534 3.929a4 4 0 0 0-.403-5.643l-3.93 4.534Zm2.821-.201a2 2 0 0 1-2.82.201l3.929-4.534a4 4 0 0 0-5.643.403l4.534 3.93Zm-4.444 5.128 4.444-5.128-4.534-3.93-4.444 5.128 4.534 3.93Zm-6.578-2.359 2.044 2.359 4.534-3.93-2.044-2.358-4.534 3.93Zm2.82.202a2 2 0 0 1-2.82-.202l4.534-3.93a4 4 0 0 0-5.643-.403l3.93 4.535Zm.202-2.822a2 2 0 0 1-.201 2.822l-3.93-4.535a4 4 0 0 0-.403 5.643l4.534-3.93Zm2.8 3.231-2.8-3.23-4.534 3.929 2.8 3.23 4.534-3.929ZM49.8 52a2 2 0 0 1 1.511.69l-4.534 3.93A4 4 0 0 0 49.8 58v-6Zm-1.511.69A2 2 0 0 1 49.8 52v6a4 4 0 0 0 3.023-1.38l-4.534-3.93Zm5.2-6-5.2 6 4.534 3.93 5.2-6-4.534-3.93Z" fill="#fff" mask="url(#a)" />
                  <path d="M40.621 28.623c.152-.113.379-.007.379.171v7.456c0 .966-.84 1.75-1.875 1.75h-16.25C21.84 38 21 37.216 21 36.25v-7.452c0-.182.223-.284.379-.171.875.634 2.035 1.44 6.02 4.141.824.562 2.214 1.743 3.601 1.736 1.395.01 2.813-1.196 3.605-1.736 3.985-2.701 5.141-3.51 6.016-4.145ZM31 33.333c.906.015 2.21-1.064 2.867-1.509 5.184-3.511 5.578-3.817 6.774-4.692a.853.853 0 0 0 .359-.69v-.692c0-.966-.84-1.75-1.875-1.75h-16.25C21.84 24 21 24.784 21 25.75v.693c0 .27.133.521.36.689 1.195.871 1.59 1.181 6.773 4.692.656.445 1.96 1.524 2.867 1.51Z" fill="#808A9D" />
                </svg>
              </p>
              <p>
                <span className="txt-muted">{t("HomeViewComp.instr_enviad")}<strong>{email}</strong></span>
                <br />
                <small style={{ color: "#cf2424", fontSize: "15px" }}>{t("HomeViewComp.sino_encuent")}</small>
              </p>
            </>
          )
        }

        {
          error && (
            <p style={{ color: "var(--danger-color)" }}>{error}</p>
          )
        }

        <form onSubmit={onHandleSubmit}>
          <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="email">{t("HomeViewComp.ingr_correo")}</label>
          <input
            style={{ marginTop: "3px" }}
            className="input-control-text"
            type="text"
            name="email-ad"
            id="email"
            value={email}
            disabled={emailSend}
            onChange={({ target }) => onHandleValEmail(target.value)}
            placeholder={t("HomeViewComp.ingr_correo")} />

          <button
            type={emailVal ? "button" : "submit"}
            disabled={emailVal}
            className={`btn-send-inst ${emailVal && "disabled-class"}`}>{t("HomeViewComp.enviar_instruc")}</button>
        </form>
      </div>
    </div>
  );
};